import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CompaniesService } from '../companies.service';

@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss'],
  providers: [ConfirmationService]
})
export class CompaniesListComponent implements OnInit {

  @ViewChild("grid") public grid:Table;
  public companiesFilters:any = {};
  public companies:any[];
  public totalRecords:number;
  public loading:boolean = false;
  private lastGridEvent:any;

  constructor(
    private companiesService:CompaniesService,
    private router:Router,
    private confirmationService: ConfirmationService,
    private messageService:MessageService
    ) { }

  ngOnInit(): void {
  }

  search(){
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  clearFilters(){
    this.companiesFilters = {};
    this.search();
  }

  loadData($event){
    this.lastGridEvent = $event;
    this.loading = true;
    var params = {
      _page: $event.first,
      _pageSize: $event.rows,
      _sortBy: $event.sortField?$event.sortField:"",
      _sortDirection: $event.sortOrder>0?"asc":"desc"
    };
    params = Object.assign(params, this.companiesFilters);
    this.companiesService.all(params).subscribe(
      data => {
        this.totalRecords = data.totalRows;
        this.companies = data.rows;
        this.loading = false;
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        this.loading = false;
      }
    );
  }

  edit(company){
    this.router.navigate(['/companies', company.id ]);
  }

  delete(company){
    this.confirmationService.confirm({
      message: '¿Quieres borrar la empresa ' + company.name + '?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.companiesService.delete(company.id).subscribe(
          data => {
            this.loadData(this.lastGridEvent);
          },
          error => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        );
      },
      reject: () => {
        
      }
    });
  }
}
